import { render, staticRenderFns } from "./budget-items.vue?vue&type=template&id=44fbcdae&scoped=true"
import script from "./budget-items.vue?vue&type=script&lang=js"
export * from "./budget-items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fbcdae",
  null
  
)

export default component.exports